import script from "./MedianPriceIndicator.vue?vue&type=script&lang=js"
export * from "./MedianPriceIndicator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__